module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Medium.5f95b44.woff2";